<template>
	<div class="row items flex-row">
		<div class="columns column12">
			<div class="gallery-wrapper flex-row">
				<div
					v-for="item in items"
					:key="item.ID"
					class="columns column4 filter-item"
					:class="{ active: filter === item.galleryCategorie.ID || filter === 'showAll' }"
				>
					<gallery-item :item="item" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.gallery-wrapper {
	background: #fff;
	display: grid;
	grid-template: repeat(3, 1fr) / repeat(3, 1fr);
	gap: 40px;

	.filter-item {
		margin: 0;
		padding: 0;
		width: 100%;
	}
}

@media (max-width: 620px) {
	.gallery-wrapper {
		grid-template: repeat(2, 1fr) / repeat(2, 1fr);
	}
}

@media (max-width: 420px) {
	.gallery-wrapper {
		grid-template: repeat(1, 1fr) / repeat(1, 1fr);
	}
}
</style>
